import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Markdown, Subtext, Avatar } from '@contently/toolkit';
import RelativeDatetime from '../toolkit/relative_datetime';
import LocalizedDate from '../toolkit/localized_date';

const Comment = props => {
  const {
    id,
    body,
    authorable,
    formattedCreatedAt,
    authorIsEmployee,
    authorIsManagingEditor
  } = props;
  const { avatar, fullName } = authorable;

  const formattedDate = <LocalizedDate formatType="datetime" timestamp={formattedCreatedAt} />;

  let authorTooltip = '';
  let authorBadge = '';
  let authorBadgeColor = 'blue.primary';

  if (authorIsEmployee) {
    authorTooltip = 'Contently employee';
    authorBadge = 'C';
  }
  if (authorIsManagingEditor) {
    authorTooltip = 'Contently managing editor';
    authorBadge = 'ME';
    authorBadgeColor = 'grey.primary';
  }

  return (
    <div className="list-item-wrapper" key={`comment-${id}`}>
      <div className="list-item avatar-presenter">
        <div className="avatar-wrapper">
          <Avatar
            src={avatar}
            alt={fullName}
            tooltip={authorTooltip}
            badgeText={authorBadge}
            badgeColor={authorBadgeColor}
          />
        </div>

        <div className="presenter-wrapper include-right-content">
          <Subtext>{fullName}</Subtext>

          <div className="right-content subtext">
            <Subtext>
              <Tooltip content={formattedDate}>
                <RelativeDatetime timestamp={formattedCreatedAt} />
              </Tooltip>
            </Subtext>
          </div>

          <div className="body">
            <Markdown>{body}</Markdown>
          </div>
        </div>
      </div>
    </div>
  );
};

Comment.defaultProps = {
  body: '',
  authorIsEmployee: false,
  authorIsManagingEditor: false
};

Comment.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  body: PropTypes.string,
  authorable: PropTypes.shape({
    avatar: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired
  }).isRequired,
  formattedCreatedAt: PropTypes.string.isRequired,
  authorIsEmployee: PropTypes.bool,
  authorIsManagingEditor: PropTypes.bool
};

export default Comment;



// WEBPACK FOOTER //
// ./app/javascript/app/components/comments/comment.jsx